import React from 'react';
import styled from 'styled-components';
import Verifyregistration from '../../components/Verifyregistration/Verifyregistration';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height: 60vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 70vh;

  }
`;



class CardVerifyregistration extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Verifyregistration />

    </Viz>

</Container>

  );
 }
}

export default CardVerifyregistration;
